import { useTranslation } from 'react-i18next';
import { t } from '../lib/i18n/t';
import { resolveLocale } from '../lib/i18n/resolveLocale';

export interface UseTReturn {
  t: (key: string, replacements?: Record<string, any>) => any;
  locale: string;
}

// ECDEX-3440: gives a component the same locale reactivity `<T>` has
// (subscribing to `react-i18next`'s `useTranslation()`, which re-renders on
// every `i18n.setLocale()` call) plus `t()`, the non-JSX equivalent of `<T>`
// for attribute values and other places a component can't render a child.
// Class components can't call hooks; wrap those with
// `i18n.renderTranslation()` (`@international/mastodon-i18n`'s `withTranslation`
// alias, already used by MatrixVerificationForm) for the same reactivity, and
// call the plain `t()` export directly instead of this hook.
const useT = (): UseTReturn => {
  const { i18n } = useTranslation();
  return { t, locale: resolveLocale(i18n.language) };
};

export default useT;
